module.exports = __webpack_public_path__ + "img/00028.ab7a450e.webp";